module.exports = __webpack_public_path__ + "img/full2-min.e85a0a72.png";